module.exports = __webpack_public_path__ + "scripts/brand-icons.svg?38975343";


//////////////////
// WEBPACK FOOTER
// ./semantic/dist/themes/default/assets/fonts/brand-icons.svg
// module id = 221
// module chunks = 1